import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * The auth pages have their own shell (auth-shell.html, <html data-tc-shell="auth">) with the current login.
 * This bundle still carries an older login, and reaching /login inside it (log out, expired session) showed that
 * one (Martin 2026-09-25: "why does the login show me the old version?"). Load those pages from the server
 * instead - once per path and 15 s, so a server that answers without the auth shell cannot loop.
 */
const AUTH_SHELL_PATHS = new Set(['/login', '/signup', '/forgot', '/verify-email', '/reset-password']);
const AUTH_HANDOFF_KEY = 'tc-auth-shell-handoff';
export const AuthShellHandoff: React.FC<{ children: React.ReactElement }> = ({ children }) => {
    const location = useLocation();
    const [handoff] = useState(() => {
        if (!import.meta.env.PROD || document.documentElement.dataset.tcShell === 'auth' || !AUTH_SHELL_PATHS.has(location.pathname)) return false;
        try {
            const last = JSON.parse(sessionStorage.getItem(AUTH_HANDOFF_KEY) || 'null');
            if (last && last.path === location.pathname && Date.now() - last.at < 15000) return false;
            sessionStorage.setItem(AUTH_HANDOFF_KEY, JSON.stringify({ path: location.pathname, at: Date.now() }));
            return true;
        } catch {
            return false;
        }
    });
    useEffect(() => {
        if (handoff) window.location.replace(location.pathname + location.search + location.hash);
    }, [handoff, location.pathname, location.search, location.hash]);
    return handoff ? null : children;
};
